import { FC, HTMLAttributes } from 'react';

import { Button, Dropdown } from 'antd';

import HamburgerLogo from 'assets/images/hamburger.svg?react';
import { MENU_ITEMS_ADV, MENU_ITEMS_PUB } from 'features/Navigation';

interface IUserInfoProps extends HTMLAttributes<HTMLDivElement> {
	isPublisher?: boolean;
}

export const HeaderMenu: FC<IUserInfoProps> = ( { isPublisher }: IUserInfoProps ) => {
	return (
		<Dropdown menu={{ items: isPublisher ? MENU_ITEMS_PUB : MENU_ITEMS_ADV }} trigger={['click']} arrow>
			<Button htmlType={'button'} icon={<HamburgerLogo />} type={'text'} size={'large'} color={'red'} />
		</Dropdown>
	);
};
